/**
 * Ivcert API v2
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient, HttpHeaders,
    HttpResponse, HttpEvent
} from '@angular/common/http';
import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
@Injectable()
export class EnvironmentService {
    protected basePath = window.location.origin.includes('localhost') ? environment.url_api : this.validatorURL(window.location.origin) + '/ivcert';
    public apiVersion = window.location.origin.includes('localhost') ? environment.apiVersion : 'v3';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        this.defaultHeaders = this.defaultHeaders.set('X-Request-ID', 'app-front');
    }

    public validatorURL(url: string) {
        const newURL: string = url.includes('//ivcert.net') ? url.replace('//ivcert.net', '//www.ivcert.net') : url.includes('//ivcert.fr') ? url.replace('//ivcert.fr', '//www.ivcert.fr') : url;
        return newURL;
    }

    /**
     *
     *
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public environmentGetListCustomCircuit(authorization: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public environmentGetListCustomCircuit(authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public environmentGetListCustomCircuit(authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public environmentGetListCustomCircuit(authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling environmentGetListCustomCircuit.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<any>(`${this.basePath}/api/${this.apiVersion}/Customization`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
